<template>
    <b-modal ref="modal"
             header-class="d-none"
             footer-class="d-none"
             :size="data.size || 'md'"
             :centered="true"
             :scrollable="false"
             :no-close-on-backdrop="true"
             :no-close-on-esc="true"
             :title-html="data.title"
             @hide="hide"
             @hidden="onClose"
             @shown="onShow"
             @ok="close(1)"
    >
        <template slot="modal-header">
            <div></div>
        </template>
        <h5 class="text-center" v-html="data.body"></h5>

        <div v-if="isNaN(data.percentage)" class="d-flex justify-content-center my-4">
            <circle-loader></circle-loader>
        </div>
        <div v-else-if="!isNaN(data.percentage)" class="d-flex justify-content-center my-4">
            <circle-loader :show-perc="true" :percentage="data.percentage"></circle-loader>
        </div>
        <template slot="modal-footer">
            <div></div>
        </template>
    </b-modal>
</template>

<script>
    import { customImport } from "@/utils";
    import modal from "@dialogs/modal.vue";
    import CircleLoader from "@configurator/comp/circleLoader";

    export default {
        mixins: [modal],
        components: {
            CircleLoader,
            sqrLoader: () => customImport("comp/sqrLoader.vue"),
            progressLoader: () => customImport("comp/progressLoader.vue")
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/dialogs/modalLoader.vue